'use client'

import { useSizes } from 'pdp/src/contexts/SizesProvider/SizesProvider'
import type { FullProduct } from 'pdp/src/types/FullProduct'
import { useCallback } from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { SizeGuideDialog } from 'size-guide/components/SizeGuideDialog/SizeGuideDialog'

interface SizeGuideModalProps {
	readonly product: FullProduct
}

export function SizeGuideModal({
	product,
}: SizeGuideModalProps): React.ReactNode {
	const { isLessThanLarge } = useResponsive()
	const { openSheet } = useSizes()

	const onSizeGuideClose = useCallback((): void => {
		if (isLessThanLarge) {
			openSheet(true)
		}
	}, [openSheet, isLessThanLarge])

	const { families, genderId } = product

	return (
		<SizeGuideDialog
			families={families}
			genderId={genderId}
			onSizeGuideClose={onSizeGuideClose}
		/>
	)
}
